








import Vue from 'vue'
import { SubscriptionInfo } from '@/models/dataTable'
import StringColumn from '@/components/DataTable/Columns/Common/StringColumn.vue'

interface Props {
  columnValue: SubscriptionInfo
  columnName: string
  directory: string
}

interface Computed {
  columnText: string
}

export default Vue.extend<{}, {}, Computed, Props>({
  components: {
    StringColumn,
  },
  props: {
    columnValue: {
      required: true,
    },
    columnName: {
      required: true,
    },
    directory: {
      required: true,
    },
  },
  computed: {
    columnText() {
      if (this.columnValue.upgrade) {
        return `${this.$tc('billing.customData.upgradeTrue')} (${this.$tc(
          'billing.customData.users',
        )}: ${this.columnValue.users}, ${this.$tc(
          'billing.customData.months',
        )}: ${this.columnValue.months})`
      }
      return `${this.$tc('billing.customData.upgradeFalse')} (${this.$tc(
        'billing.customData.users',
      )}: ${this.columnValue.users}, ${this.$tc(
        'billing.customData.months',
      )}: ${this.columnValue.months})`
    },
  },
})
